export const luckyBirdUserTypes = {
  singleLogic: 1,
  pointsLogic: 2,
} as const

export type LuckyBirdUserType = (typeof luckyBirdUserTypes)[keyof typeof luckyBirdUserTypes]
